import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"
import { Link } from "../../../../plugins/gatsby-plugin-atollon"
import { Australia } from "../../icons"

const AvailableRole = ({ title, items, richContent }) => {

  const elementRef = React.useRef(null);

  React.useEffect(() => {
    const availableItems = elementRef.current?.querySelectorAll('.available-role__item');

    const toggleActive = (item, circle, add) => {
      item.classList.toggle('active', add);
      circle.classList.toggle('active', add);
    };

    // Add hover event listeners
    availableItems.forEach(item => {
      const circleId = item.dataset.name;
      const circle = document.querySelector(`svg#Australia circle#${circleId}`);

      if (circle) {
        // Item hover events
        item.addEventListener('mouseenter', () => toggleActive(item, circle, true));
        item.addEventListener('mouseleave', () => toggleActive(item, circle, false));

        // Circle hover events
        circle.addEventListener('mouseenter', () => toggleActive(item, circle, true));
        circle.addEventListener('mouseleave', () => toggleActive(item, circle, false));
      } else {
        console.warn(`No circle found with ID: ${circleId}`);
      }
    });

    return () => {
      // Cleanup event listeners when component unmounts
      availableItems.forEach(item => {
        const circleId = item.dataset.name;
        const circle = document.querySelector(`svg#Australia circle#${circleId}`);

        if (circle) {
          item.removeEventListener('mouseenter', () => toggleActive(item, circle, true));
          item.removeEventListener('mouseleave', () => toggleActive(item, circle, false));
          circle.removeEventListener('mouseenter', () => toggleActive(item, circle, true));
          circle.removeEventListener('mouseleave', () => toggleActive(item, circle, false));
        }
      });
    };
  }, [items]);

  // Hide circles not corresponding to items
  React.useEffect(() => {
    const circles = document.querySelectorAll('svg#Australia circle');
    const itemNames = new Set(items.map(item => item.location.toLowerCase().replace(/\s/g, '-')));

    circles.forEach(circle => {
      const circleId = circle.getAttribute('id');
      if (!itemNames.has(circleId)) {
        circle.style.display = 'none'; // Hide the circle
      } else {
        circle.style.display = 'block'; // Ensure it is visible if it matches an item
      }
    });
  }, [items]);

  return (
    <section className="available-role" ref={elementRef} id="available-roles">
      <div className="available-role__inner">
        <div className="available-role__title">
          {title && <span className="btn btn--orange">{parse(title)}</span>}
          <div className="line line--horizon center-left"></div>
        </div>
        <div className="available-role__wrapper">
          <div className="line line--vertical center-top"></div>

          <div className="available-role__map">
            <Australia />
          </div>
          {richContent && <div className="available-role__content available-role__content--mobile"><StructuredText data={richContent} /></div>}
          <div className="available-role__roles">
            {richContent && <div className="available-role__content available-role__content--desktop"><StructuredText data={richContent} /></div>}
            <div className="available-role__items">
              {
                items && items.length > 0 && items.map((item, index) => (
                  <Link key={index} {...item.link} target='_blank' rel='noopener noreferrer' className="available-role__item" data-name={item.location.toLowerCase().replace(/\s/g, '-')}>
                    <div className="line line--horizon center-left"></div>
                    <div className="available-role__item--title">
                      {item.location && <h4>{parse(item.location)}</h4>}
                      {item.title && <h3>{parse(item.title)}</h3>}
                    </div>
                    {item.enviroment && <span>{parse(item.enviroment)}</span>}
                    {item.hour && <span>{parse(item.hour)}</span>}
                  </Link>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AvailableRole

export const query = graphql`
  fragment AvailableRoleProps on DatoCmsAvailableRole {
  ... on DatoCmsAvailableRole {
    id
    title
    richContent {
      value
    }
    items {
      title
      slug
      location
      enviroment
      hour
      link {
        ...LinkWithoutTitleProps
      }
    }
  }
}
`
